import Button from '~/components/Button';
import reneeImage from '~/images/renee.jpg';
import type { V2_MetaFunction } from '~/remix';

export let meta: V2_MetaFunction = () => [
  { title: 'Sunset Messages - Dedication' },
];

export default function () {
  return (
    <div className="bg-white text-center text-accent-medium">
      <div className="sticky top-0 z-20 w-full bg-accent-dark/70 py-2 text-white">
        <h1 className="text-center text-2xl font-bold">Dedication</h1>
      </div>
      <div className="h-4 w-full bg-white"></div>
      <div className="prose mx-4 text-center sm:mx-auto">
        <p className="text-lg font-medium sm:mt-4 sm:text-3xl">
          This site is dedicated to one of the most amazing people to have ever
          lived
        </p>
        <p className="m-0 font-serif text-2xl font-medium text-accent-medium md:text-4xl">
          Renée Maria Reisch-Payne
        </p>
      </div>
      <div className="mt-4 sm:mt-8">
        <div className="flex flex-col items-center">
          <div>
            <img
              src={reneeImage}
              alt="Renée Maria"
              className="w-144 m-0 border shadow-2xl"
            />
            <div className="mt-1 text-sm sm:mt-2 sm:text-base">
              June 2, 1970 &ndash; April 5, 2020
            </div>
          </div>
        </div>
        <div className="text-md container prose mx-auto mt-8 w-96 px-4 text-center font-medium sm:w-[512px] sm:px-0 sm:text-2xl">
          <p>
            Renée was an inspiration to so many people
            <br />
            and a great encourager toward
            <br />
            the creation of this site.
          </p>

          <p>Hopefully she was a part of your life too.</p>

          <p>
            By bringing this site to life, we hope to share
            <br />
            her vision and inspiration with you all.
          </p>

          <p>
            Let’s honor Renée as you help us make this site
            <br />
            all that it has the potential to be.
          </p>

          <div className="not-prose">
            <Button type="link" to="/" size="lg" variant="secondary">
              Return to Home Page
            </Button>
          </div>
          <div className="h-8"></div>
        </div>
      </div>
    </div>
  );
}
